<template>
	<svg aria-hidden="true" :class="svgClass">
		<use :xlink:href="`#icon-${name}`"></use>
	</svg>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
	name: String,
	className: String
})

const svgClass = computed(() => {
	if (props.className) {
		return 'svg-icon ' + props.className
	} else {
		return 'svg-icon'
	}
})
</script>

<style lang="less" scoped>
.svg-icon {
	width: 1em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
</style>